import React from "react";
import { History } from "../../components";

const HistoyUser = () =>{
    return(
        <History/>
    )
}

export default HistoyUser;